<template>
  <div id="OutStockCalcPlan" style="margin: 0px auto">
    <div class="breadcrumb-box">
      <span class="back-btn" @click="goBack">《</span>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>采购管理</el-breadcrumb-item>
        <el-breadcrumb-item>出库管理</el-breadcrumb-item>
        <el-breadcrumb-item>测算方案</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="plan-conent" id="subOutputRank-print">
      <div class="shop-content">
        <div class="title-content">
          <span class="title-label">出口计划编号：</span>
          <span class="title-text">{{ outStockPlan.planId }}</span>
          <span class="title-label" style="margin-left: 20px">头程物流：</span>
          <span class="title-text">{{ getLogisticsTypeLabel(outStockPlan.logisticsType) }}</span>
          <span class="title-label" style="margin-left: 20px">店铺名称：</span>
          <span class="title-text">{{ outStockPlan.shopName }}</span>
          <span class="title-label" style="margin-left: 20px">出库日期：</span>
          <span class="title-text">{{ outStockPlan.date }}</span>
          <span class="title-label" style="margin-left: 20px">出库数量：</span>
          <span class="title-text">{{ outStockPlan.outStockCount }}</span>
        </div>
        <div class="title-content">
          <span class="title-label">一箱出库量：</span>
          <span class="title-text">{{ outStockPlan.outStockCountFor1Box }}</span>
          <span class="title-label" style="margin-left: 20px">两箱出库量：</span>
          <span class="title-text">{{ outStockPlan.outStockCountFor2Box }}</span>
          <span class="title-label" style="margin-left: 20px">三箱出库量：</span>
          <span class="title-text">{{ outStockPlan.outStockCountFor3Box }}</span>
          <span class="title-label" style="margin-left: 20px">四箱出库量：</span>
          <span class="title-text">{{ outStockPlan.outStockCountFor4Box }}</span>
          <span class="title-label" style="margin-left: 20px">五箱出库量：</span>
          <span class="title-text">{{ outStockPlan.outStockCountFor5Box }}</span>
        </div>
      </div>

      <div class="shop-content">
        <div class="title-content">
          <span class="title-label">每箱数量：</span>
          <el-input v-model="perBoxCount" type="number" style="width: 100px" size="mini"></el-input>
          <span class="title-label" style="margin-left: 20px">每公斤数量：</span>
          <el-input v-model="perBubbleWeightCount" type="number" style="width: 100px" size="mini"></el-input>
          <span class="title-label" style="margin-left: 20px">头程价格：</span>
          <el-input v-model="perKgFee" type="number" style="width: 100px" size="mini"></el-input>
          <span class="title-label" style="margin-left: 20px">平均产品重量：</span>
          <el-input v-model="averageProductWeight" type="number" style="width: 100px" size="mini"></el-input>
          <span class="title-label" style="margin-left: 20px">冗余数量：</span>
          <el-input v-model="redundantCount" type="number" style="width: 100px" size="mini"></el-input>
          <span class="title-label" style="margin-left: 20px">减少数量：</span>
          <el-input v-model="reduceCount" type="number" style="width: 100px" size="mini"></el-input>

          <el-button type="primary" size="mini" @click="calcOutStockPlan" style="margin-left: 20px">重新测算</el-button>
        </div>
      </div>

      <div class="title-line">箱子测算详情</div>
      <div class="box-content">
        <el-table :data="calcData" stripe :highlight-current-row="true">
          <el-table-column label="箱子规格" width="70px" align="center">
            <el-table-column label="" width="60px">
              <template slot-scope="scope">
                {{ "规格" + (scope.$index + 1) }}
              </template>
            </el-table-column>
            <el-table-column prop="length" label="长" width="40px" align="right"> </el-table-column>
            <el-table-column prop="width" label="宽" width="40px" align="right"> </el-table-column>
            <el-table-column prop="height" label="高" width="40px" align="right"> </el-table-column>
            <el-table-column prop="volume" label="体积" width="60px" align="right"> </el-table-column>
            <el-table-column prop="bubbleRatio" label="泡比" width="50px" align="right"> </el-table-column>
            <el-table-column prop="bubbleWeight" label="泡重" width="50px" align="right">
              <template slot-scope="scope"> {{ scope.row.bubbleWeight.toFixed(2) }} </template>
            </el-table-column>
            <el-table-column prop="chargeableWeight" label="收费重量" width="40px" align="right"> </el-table-column>
          </el-table-column>

          <el-table-column label="货物数量" width="90px" align="center">
            <el-table-column prop="countFor1Box" label="1箱" width="50px" align="right">
              <template slot-scope="scope"> {{ Math.ceil(scope.row.countFor1Box) }} </template>
            </el-table-column>
            <el-table-column prop="countFor2Box" label="2箱" width="50px" align="right">
              <template slot-scope="scope"> {{ Math.ceil(scope.row.countFor2Box) }} </template>
            </el-table-column>
            <el-table-column prop="countFor3Box" label="3箱" width="50px" align="right">
              <template slot-scope="scope"> {{ Math.ceil(scope.row.countFor3Box) }} </template>
            </el-table-column>
            <el-table-column prop="countFor4Box" label="4箱" width="50px" align="right">
              <template slot-scope="scope"> {{ Math.ceil(scope.row.countFor4Box) }} </template>
            </el-table-column>
            <el-table-column prop="countFor5Box" label="5箱" width="50px" align="right">
              <template slot-scope="scope"> {{ Math.ceil(scope.row.countFor5Box) }} </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="实际重量" width="90px" align="center">
            <el-table-column prop="realWeightFor1Box" label="1箱" width="60px" align="right">
              <template slot-scope="scope"> {{ scope.row.realWeightFor1Box.toFixed(2) }} </template>
            </el-table-column>
            <el-table-column prop="realWeightFor2Box" label="2箱" width="60px" align="right">
              <template slot-scope="scope"> {{ scope.row.realWeightFor2Box.toFixed(2) }} </template>
            </el-table-column>
            <el-table-column prop="realWeightFor3Box" label="3箱" width="60px" align="right">
              <template slot-scope="scope"> {{ scope.row.realWeightFor3Box.toFixed(2) }} </template>
            </el-table-column>
            <el-table-column prop="realWeightFor4Box" label="4箱" width="60px" align="right">
              <template slot-scope="scope"> {{ scope.row.realWeightFor4Box.toFixed(2) }} </template>
            </el-table-column>
            <el-table-column prop="realWeightFor5Box" label="5箱" width="60px" align="right">
              <template slot-scope="scope"> {{ scope.row.realWeightFor5Box.toFixed(2) }} </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="收费重量" width="90px" align="center">
            <el-table-column prop="chargeableWeightFor1Box" label="1箱" width="50px" align="right">
              <template slot-scope="scope"> {{ Math.ceil(scope.row.chargeableWeightFor1Box) }} </template>
            </el-table-column>
            <el-table-column prop="chargeableWeightFor2Box" label="2箱" width="50px" align="right">
              <template slot-scope="scope"> {{ Math.ceil(scope.row.chargeableWeightFor2Box) }} </template>
            </el-table-column>
            <el-table-column prop="chargeableWeightFor3Box" label="3箱" width="50px" align="right">
              <template slot-scope="scope"> {{ Math.ceil(scope.row.chargeableWeightFor3Box) }} </template>
            </el-table-column>
            <el-table-column prop="chargeableWeightFor4Box" label="4箱" width="50px" align="right">
              <template slot-scope="scope"> {{ Math.ceil(scope.row.chargeableWeightFor4Box) }} </template>
            </el-table-column>
            <el-table-column prop="chargeableWeightFor5Box" label="5箱" width="50px" align="right">
              <template slot-scope="scope"> {{ Math.ceil(scope.row.chargeableWeightFor5Box) }} </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="分拣费" width="90px" align="center">
            <el-table-column prop="bulkFeeFor1Box" label="1箱" width="60px" align="right">
              <template slot-scope="scope"> {{ scope.row.bulkFeeFor1Box.toFixed(2) }} </template>
            </el-table-column>
            <el-table-column prop="bulkFeeFor2Box" label="2箱" width="60px" align="right">
              <template slot-scope="scope"> {{ scope.row.bulkFeeFor2Box.toFixed(2) }} </template>
            </el-table-column>
            <el-table-column prop="bulkFeeFor3Box" label="3箱" width="60px" align="right">
              <template slot-scope="scope"> {{ scope.row.bulkFeeFor3Box.toFixed(2) }} </template>
            </el-table-column>
            <el-table-column prop="bulkFeeFor4Box" label="4箱" width="60px" align="right">
              <template slot-scope="scope"> {{ scope.row.bulkFeeFor4Box.toFixed(2) }} </template>
            </el-table-column>
            <el-table-column prop="bulkFeeFor5Box" label="5箱" width="60px" align="right">
              <template slot-scope="scope"> {{ scope.row.bulkFeeFor5Box.toFixed(2) }} </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="头程费" width="90px" align="center">
            <el-table-column prop="logisticsCostFor1Box" label="1箱" width="50px" align="right">
              <template slot-scope="scope"> {{ Math.round(scope.row.logisticsCostFor1Box) }} </template>
            </el-table-column>
            <el-table-column prop="logisticsCostFor2Box" label="2箱" width="50px" align="right">
              <template slot-scope="scope"> {{ Math.round(scope.row.logisticsCostFor2Box) }} </template>
            </el-table-column>
            <el-table-column prop="logisticsCostFor3Box" label="3箱" width="50px" align="right">
              <template slot-scope="scope"> {{ Math.round(scope.row.logisticsCostFor3Box) }} </template>
            </el-table-column>
            <el-table-column prop="logisticsCostFor4Box" label="4箱" width="50px" align="right">
              <template slot-scope="scope"> {{ Math.round(scope.row.logisticsCostFor5Box) }} </template>
            </el-table-column>
            <el-table-column prop="logisticsCostFor5Box" label="5箱" width="50px" align="right">
              <template slot-scope="scope"> {{ Math.round(scope.row.logisticsCostFor5Box) }} </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="合计费用" width="90px" align="center">
            <el-table-column prop="sumFeeFor1Box" label="1箱" width="60px" align="right">
              <template slot-scope="scope"> {{ scope.row.sumFeeFor1Box.toFixed(2) }} </template>
            </el-table-column>
            <el-table-column prop="sumFeeFor2Box" label="2箱" width="60px" align="right">
              <template slot-scope="scope"> {{ scope.row.sumFeeFor2Box.toFixed(2) }} </template>
            </el-table-column>
            <el-table-column prop="sumFeeFor3Box" label="3箱" width="60px" align="right">
              <template slot-scope="scope"> {{ scope.row.sumFeeFor3Box.toFixed(2) }} </template>
            </el-table-column>
            <el-table-column prop="sumFeeFor4Box" label="4箱" width="60px" align="right">
              <template slot-scope="scope"> {{ scope.row.sumFeeFor4Box.toFixed(2) }} </template>
            </el-table-column>
            <el-table-column prop="sumFeeFor5Box" label="5箱" width="60px" align="right">
              <template slot-scope="scope"> {{ scope.row.sumFeeFor5Box.toFixed(2) }} </template>
            </el-table-column>
          </el-table-column>

          <el-table-column label="每公斤成本" width="90px" align="center">
            <el-table-column prop="perKgCostFor1Box" label="1箱" width="60px" align="right">
              <template slot-scope="scope"> {{ scope.row.perKgCostFor1Box.toFixed(2) }} </template>
            </el-table-column>
            <el-table-column prop="perKgCostFor2Box" label="2箱" width="60px" align="right">
              <template slot-scope="scope"> {{ scope.row.perKgCostFor2Box.toFixed(2) }} </template>
            </el-table-column>
            <el-table-column prop="perKgCostFor3Box" label="3箱" width="60px" align="right">
              <template slot-scope="scope"> {{ scope.row.perKgCostFor3Box.toFixed(2) }} </template>
            </el-table-column>
            <el-table-column prop="perKgCostFor4Box" label="4箱" width="60px" align="right">
              <template slot-scope="scope"> {{ scope.row.perKgCostFor4Box.toFixed(2) }} </template>
            </el-table-column>
            <el-table-column prop="perKgCostFor5Box" label="5箱" width="60px" align="right">
              <template slot-scope="scope"> {{ scope.row.perKgCostFor5Box.toFixed(2) }} </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>

      <!-- <div class="title-line">推荐方案列表</div> -->
      <div class="plan-info" style="width: 900px; display: none">
        <el-table :data="outStockPlanList" stripe :highlight-current-row="true">
          <el-table-column label="方案编号" width="80px">
            <template slot-scope="scope">
              {{ "方案" + (scope.$index + 1) }}
            </template>
          </el-table-column>

          <el-table-column prop="totalFee" label="总费用" width="80px" align="right">
            <template slot-scope="scope"> {{ scope.row.totalFee.toFixed(2) }} </template>
          </el-table-column>
          <el-table-column prop="totalCount" label="应发数量" width="80px" align="right">
            <template slot-scope="scope"> {{ outStockPlan["outStockCountFor" + scope.row.boxType + "Box"] }} </template>
          </el-table-column>
          <el-table-column prop="totalCount" label="发货数量" width="80px" align="right">
            <template slot-scope="scope"> {{ scope.row.totalCount.toFixed(0) }} </template>
          </el-table-column>
          <el-table-column prop="totalCount" label="差值数量" width="80px" align="right">
            <template slot-scope="scope">
              <span :class="getDiffCountStyle(scope.row)">{{ (scope.row.totalCount - outStockPlan["outStockCountFor" + scope.row.boxType + "Box"]).toFixed(0) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="realWeight" label="实际重量" width="80px" align="right">
            <template slot-scope="scope"> {{ scope.row.realWeight.toFixed(2) }} </template>
          </el-table-column>
          <el-table-column prop="perKgCost" label="每公斤成本" width="90px" align="right">
            <template slot-scope="scope"> {{ scope.row.perKgCost.toFixed(2) }} </template>
          </el-table-column>
          <el-table-column label="箱子规格" width="220px">
            <template slot-scope="scope">
              <template v-for="box in scope.row.boxList">
                <div class="box-info">
                  <span class="box-count">{{ scope.row.boxType + " * " }}</span>
                  <span class="box-model">{{ box.boxModel }}</span>
                </div>
              </template>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="80px">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="choosePlan(scope.row)">选择方案</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="redundant-box" style="width: 1000px; display: inline-block; vertical-align: top" v-if="chooseOutStockPlan.planType == 2">
        <div class="opreate-box" v-if="showOpreateBox">
          <span class="opreate-text">应出库数量：{{ chooseOutStockPlan.totalCount }}</span>
          <span class="opreate-text">当前出库数量：{{ getSumRedundantCountAndOutStockCount() }}</span>
          <span class="opreate-text">应增加数量：{{ chooseOutStockPlan.totalCount - this.getSumRedundantCountAndOutStockCount() }}</span>

          <el-button type="primary" size="mini" @click="autoAdd" style="margin-left: 20px" v-if="!isConfirmAdd">一键添加</el-button>
          <el-button type="primary" size="mini" @click="confirmAdd" style="margin-left: 20px" v-if="isOutStockPlanOk && !isConfirmAdd">确定添加</el-button>
          <el-button type="primary" size="mini" @click="confirmRedundantPlan" style="margin-left: 20px" v-if="isConfirmAdd">确定方案</el-button>
        </div>
        <el-table ref="redundantTable" v-if="isConfirmAdd == false" :data="redundantAsinStockList" stripe size="mini" :highlight-current-row="true" show-summary>
          <!-- <el-table-column type="selection" width="40" align="center"></el-table-column> -->
          <el-table-column prop="level" label="权重等级" width="50px" align="center"></el-table-column>
          <el-table-column prop="productName" label="产品名称" width="100px"> </el-table-column>
          <el-table-column prop="productColorName" label="颜色" width="90px"> </el-table-column>
          <el-table-column prop="sku" label="SKU" width="230px">
            <template slot-scope="scope">
              <span @click="copySku(scope.row['seller-sku'])">{{ scope.row["seller-sku"] }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="model" label="机型" width="80px"> </el-table-column>
          <el-table-column prop="maxRedundantOutStockCount" label="可冗余数量" width="50px" align="right"> </el-table-column>
          <el-table-column label="冗余数量" width="50px" align="right">
            <template slot-scope="scope">
              <span class="redText" @click="onRedundantCountClick(scope.row)" style="cursor: pointer">{{ scope.row.redundantOutStockCount > 0 ? scope.row.redundantOutStockCount : "" }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="localInventory" label="本地库存" width="50px" align="right"> </el-table-column> -->
          <!-- <el-table-column prop="fnsku" label="FNSKU" width="110px" align="center"></el-table-column> -->
          <el-table-column label="操作" width="150px" :key="17" align="center">
            <template slot-scope="scope">
              <el-button class="opreate-btn" type="text" size="small" @click="addToOutStockPlan(scope.row)">添加</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-table v-if="isConfirmAdd" :data="redundantPlanAsinStockList" stripe size="mini" :highlight-current-row="true" show-summary>
          <!-- <el-table-column type="selection" width="40" align="center"></el-table-column> -->
          <el-table-column prop="level" label="权重等级" width="50px" align="center"></el-table-column>
          <el-table-column prop="productName" label="产品名称" width="90px"> </el-table-column>
          <el-table-column prop="productColorName" label="颜色" width="90px"> </el-table-column>
          <el-table-column prop="sku" label="SKU" width="220px">
            <template slot-scope="scope">
              <span @click="copySku(scope.row.sku)">{{ scope.row.sku }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="model" label="机型" width="80px"> </el-table-column>
          <el-table-column prop="outStockCount" label="出库数量" width="50px" align="right">
            <template slot-scope="scope">
              <span>{{ scope.row.outStockCount > 0 ? scope.row.outStockCount : "-" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="redundantCount" label="冗余数量" width="50px" align="right">
            <template slot-scope="scope">
              <span class="redText">{{ scope.row.redundantCount > 0 ? scope.row.redundantCount : "-" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="totalOutStockCount" label="合计数量" width="50px" align="right"> </el-table-column>
          <!-- <el-table-column prop="localInventory" label="本地库存数量" width="50px" align="right" sortable> </el-table-column> -->
          <!-- <el-table-column prop="fnsku" label="FNSKU" width="110px" align="center"></el-table-column> -->
          <!-- <el-table-column label="操作" width="150px" :key="17" align="center">
            <template slot-scope="scope"> </template>
          </el-table-column> -->
        </el-table>
      </div>
      <div class="reduce-box" style="width: 1000px; display: inline-block; vertical-align: top" v-if="chooseOutStockPlan.planType == 3">
        <div class="opreate-box">
          <span class="opreate-text">应出库数量：{{ chooseOutStockPlan.totalCount }}</span>
          <span class="opreate-text">当前出库数量：{{ outStockPlan.outStockCount }}</span>
          <span class="opreate-text">应移除数量：{{ outStockPlan.outStockCount - chooseOutStockPlan.totalCount }}</span>

          <el-button type="primary" size="mini" @click="autoRemove" style="margin-left: 20px">一键移除</el-button>
          <el-button type="primary" size="mini" @click="confirmReducePlan" style="margin-left: 20px" v-if="isOutStockPlanOk">确定方案</el-button>
        </div>

        <el-table :data="choosePlanAsinStockList" stripe size="mini" :highlight-current-row="true" show-summary>
          <!-- <el-table-column type="selection" width="40" align="center"></el-table-column> -->
          <el-table-column prop="level" label="权重等级" width="50px" align="center"></el-table-column>
          <el-table-column prop="productName" label="产品名称" width="90px"> </el-table-column>
          <el-table-column prop="productColorName" label="颜色" width="90px"> </el-table-column>
          <el-table-column prop="sku" label="SKU" width="220px">
            <template slot-scope="scope">
              <span @click="copySku(scope.row.sku)">{{ scope.row.sku }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="model" label="机型" width="80px"> </el-table-column>
          <el-table-column prop="outStockCount" label="出库数量" width="50px" align="right"> </el-table-column>
          <!-- <el-table-column prop="localInventory" label="本地库存" width="50px" align="right"> </el-table-column> -->
          <!-- <el-table-column prop="fnsku" label="FNSKU" width="110px" align="center"></el-table-column> -->
          <el-table-column prop="removeCount" label="移除数量" width="50px" align="center">
            <template slot-scope="scope">
              <span class="redText" @click="onRemoveCountClick(scope.row)" style="cursor: pointer">{{ scope.row.removeCount != 0 ? scope.row.removeCount : "" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150px" :key="17" align="center">
            <template slot-scope="scope">
              <el-button class="opreate-btn" type="text" size="small" @click="removeProductFromPlan(scope.row)">移除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- <el-dialog title="拆分" :visible.sync="splitDialogFormVisible" width="20%">
      <div class="form-line">
        <span class="form-label">合计数量：</span>
        <span class="form-text">{{ this.splitParams.leftCount }}</span>
      </div>
      <div class="form-line">
        <span class="form-label">剩余数量：</span>
        <span class="form-text">{{ this.splitParams.leftCount - this.splitParams.splitCount }}</span>
      </div>
      <div class="form-line">
        <span class="form-label">拆分数量：</span>
        <el-input class="form-input" placeholder="请输入" v-model="splitParams.splitCount" size="small" clearable> </el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="splitDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="splitHandleConfirm">确 定</el-button>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import { requestModules } from "@r";

export default {
  data() {
    return {
      splitDialogFormVisible: false,
      params: {
        planId: this.$route.query.planId,
      },
      calcPlan: {},
      perBoxCount: 260,
      perBubbleWeightCount: 21.67,
      averageProductWeight: 0.045,
      perKgFee: 18,
      redundantCount: 300,
      reduceCount: 100,
      calcData: [],
      outStockBoxs: [],
      outStockPlan: {},
      outStockPlanList: [],
      choosePlanAsinStockList: [],
      chooseOutStockPlan: {},
      isOutStockPlanOk: false,
      purchasePlansForOutStock: [],
      redundantAsinStockList: [],
      isConfirmAdd: false,
      showOpreateBox: false,

      finalRedundantAsinStockList: [],
      finalReduceAsinStockList: [],
      redundantPlanAsinStockList: [],
    };
  },
  mounted() {
    // this.fetchOutStockPlan();
    this.fetchOutStockBoxs();

    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    goBack() {
      window.history.back();
    },
    getDiffCountStyle(row) {
      let diffCount = Math.round(row.totalCount - this.outStockPlan["outStockCountFor" + row.boxType + "Box"]);
      let styleText = "";
      diffCount > 0 && (styleText = "greenText");
      diffCount < 0 && (styleText = "redText");
      return styleText;
    },
    addToOutStockPlan(row) {
      if (row.redundantOutStockCount > 0) {
        row.redundantOutStockCount = row.redundantOutStockCount + row.maxRedundantOutStockCount;
        row.maxRedundantOutStockCount = 0;
      } else {
        row.redundantOutStockCount = row.maxRedundantOutStockCount;
        row.maxRedundantOutStockCount = 0;
      }

      this.initChooseOutStockPlanForReduce();

      this.$refs.redundantTable.doLayout();

      this.refreshRedundantOpreateBox();
    },
    refreshRedundantOpreateBox() {
      this.showOpreateBox = false; // 先隐藏组件
      this.$nextTick(() => {
        // 确保DOM更新后再次显示组件，强制重新渲染
        this.showOpreateBox = true;
      });
    },
    getSumRedundantCountAndOutStockCount() {
      let outStockCount = 0;
      let asinStockList = this.getAsinStockList();
      asinStockList.forEach(asinStock => (outStockCount += asinStock["outStockCountFor" + this.chooseOutStockPlan.boxType + "Box"]));
      // this.outStockPlan.outStockCount = outStockCount;

      let redundantCount = 0;
      this.redundantAsinStockList.forEach(item => (redundantCount += item.redundantOutStockCount > 0 ? item.redundantOutStockCount : 0));
      console.log(redundantCount, outStockCount, redundantCount + outStockCount);
      return redundantCount + outStockCount;
    },
    choosePlan(row) {
      this.chooseOutStockPlan = row;
      let boxType = row.boxType;
      let outStockCount = this.outStockPlan["outStockCountFor" + row.boxType + "Box"];

      this.choosePlanAsinStockList = this.getReduceOutStockList(boxType);
      this.reInitChoosePlanAsinStockList();
      if (outStockCount > row.totalCount) {
        this.initChooseOutStockPlanForReduce();
      } else if (outStockCount < row.totalCount) {
        this.reInitPurchasePlansForOutStock();
        this.redundantAsinStockList = this.getRedundantOutStockList(boxType);
        this.initChooseOutStockPlanForRedundant();
        this.isConfirmAdd = false;
        this.refreshRedundantOpreateBox();
      } else {
        // list = this.getReduceOutStockList(type)
      }
      this.isOutStockPlanOk = false;
    },
    reInitChoosePlanAsinStockList() {
      let list = [...this.choosePlanAsinStockList];
      list.forEach(asinStock => {
        asinStock.outStockCount = asinStock["outStockCountFor" + this.chooseOutStockPlan.boxType + "Box"];
        asinStock.removeCount = 0;
      });
      list = list.filter(asinStock => asinStock.outStockCount > 0);
      this.choosePlanAsinStockList = list;
    },
    reInitPurchasePlansForOutStock() {
      this.purchasePlansForOutStock.forEach(item => {
        item.maxRedundantOutStockCount = item["maxRedundantOutStockCountFor" + this.chooseOutStockPlan.boxType + "Box"];
        item.redundantOutStockCount = 0;
      });
    },
    initChooseOutStockPlanForRedundant() {
      this.isOutStockPlanOk = this.chooseOutStockPlan.totalCount - this.getSumRedundantCountAndOutStockCount() == 0;
    },
    initChooseOutStockPlanForReduce() {
      let outStockCount = 0;
      let asinStockList = this.getAsinStockList();
      asinStockList.forEach(asinStock => (outStockCount += asinStock.outStockCount));
      this.outStockPlan.outStockCount = outStockCount;

      this.isOutStockPlanOk = this.outStockPlan.outStockCount - this.chooseOutStockPlan.totalCount == 0;
    },
    fetchPurchasePlansForOutStock() {
      // 用于冗余产品
      requestModules.fetchPurchasePlansForOutStock({ shopType: this.outStockPlan.shopType, boxType: 5 }).then(res => {
        this.purchasePlansForOutStock = res.ldata;
      });
    },
    autoAdd() {
      let outStockCount = this.getSumRedundantCountAndOutStockCount();
      let redundantOutStockCount = this.chooseOutStockPlan.totalCount - outStockCount;
      this.redundantAsinStockList.forEach(asinStock => {
        if (redundantOutStockCount > 0 && asinStock.maxRedundantOutStockCount > 0) {
          if (redundantOutStockCount > asinStock.maxRedundantOutStockCount) {
            asinStock.redundantOutStockCount = asinStock.redundantOutStockCount + asinStock.maxRedundantOutStockCount;
            asinStock.maxRedundantOutStockCount = 0;
            redundantOutStockCount -= asinStock.redundantOutStockCount;
          } else {
            asinStock.redundantOutStockCount = asinStock.redundantOutStockCount + redundantOutStockCount;
            asinStock.maxRedundantOutStockCount = asinStock.maxRedundantOutStockCount - redundantOutStockCount;
            redundantOutStockCount = 0;
          }
        }
      });
      this.initChooseOutStockPlanForRedundant();
    },
    autoRemove() {
      let removeCount = this.outStockPlan.outStockCount - this.chooseOutStockPlan.totalCount;
      this.choosePlanAsinStockList.forEach(asinStock => {
        if (removeCount > 0 && asinStock.outStockCount > 0) {
          let asinStockRemoveCount = asinStock.removeCount > 0 ? parseInt(asinStock.removeCount) : 0;
          if (removeCount > asinStock.outStockCount) {
            asinStock.removeCount = asinStock.outStockCount + asinStockRemoveCount;
            asinStock.outStockCount = 0;
            removeCount -= asinStock.removeCount;
          } else {
            asinStock.removeCount = asinStockRemoveCount + removeCount;
            asinStock.outStockCount = asinStock.outStockCount - removeCount;
            removeCount = 0;
          }
        }
      });

      this.initChooseOutStockPlanForReduce();
    },
    confirmRedundantPlan() {
      this.confirmOutStockPlan({ planId: this.outStockPlan.planId, finalRedundantAsinStockList: JSON.stringify(this.finalRedundantAsinStockList), chooseOutStockPlan: JSON.stringify(this.chooseOutStockPlan) });
    },
    confirmReducePlan() {
      let list = [];
      this.choosePlanAsinStockList.forEach(asinStock => asinStock.removeCount > 0 && list.push({ sku: asinStock.sku, reduceOutStockCount: asinStock.removeCount }));
      this.finalReduceAsinStockList = list;

      this.confirmOutStockPlan({ planId: this.outStockPlan.planId, finalReduceAsinStockList: JSON.stringify(this.finalReduceAsinStockList), chooseOutStockPlan: JSON.stringify(this.chooseOutStockPlan) });
    },
    confirmAdd() {
      let list = [];
      this.redundantAsinStockList.forEach(
        plan =>
          plan.redundantOutStockCount > 0 &&
          list.push({
            asin: plan.asin,
            sku: plan["seller-sku"],
            redundantOutStockCount: plan.redundantOutStockCount,
            outStockCount: 0,
            purchaseColorName: plan.purchaseColorName,
            productName: plan.productName,
            level: plan.level,
            model: plan.model,
            shopType: plan.shopType,
            shopName: plan.shopName,
            productColor: plan.productColor,
            price: plan.price,
            logisticsType: plan.logisticsType,
            localInventory: plan.localInventory,
          })
      );
      this.finalRedundantAsinStockList = list;

      this.initRedundantPlanAsinStockList();

      this.isConfirmAdd = true;
    },
    confirmOutStockPlan(params) {
      requestModules
        .confirmOutStockPlan(params)
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "编辑失败",
            });
            return;
          }
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    initRedundantPlanAsinStockList() {
      let skus = new Set([]);
      this.choosePlanAsinStockList.forEach(asinStock => skus.add(asinStock.sku));
      this.finalRedundantAsinStockList.forEach(asinStock => skus.add(asinStock.sku));
      let skuList = [...skus];
      let list = [];
      skuList.forEach(sku => {
        let asinStock1 = this.choosePlanAsinStockList.find(asinStock => asinStock.sku == sku);
        let asinStock2 = this.finalRedundantAsinStockList.find(asinStock => asinStock.sku == sku);
        let outStockCount = asinStock1 ? asinStock1.outStockCount : 0;
        let redundantCount = asinStock2 ? asinStock2.redundantOutStockCount : 0;

        let asinStock = asinStock1 ? asinStock1 : asinStock2;
        console.log(asinStock, asinStock1, asinStock2);
        list.push({
          ...asinStock,
          outStockCount,
          redundantCount,
          totalOutStockCount: outStockCount + redundantCount,
        });
      });
      this.redundantPlanAsinStockList = list;
      console.log(list);

      let sortFun = function (a, b) {
        if (!a.productName || !a.productColor || !a.model || !b.productName || !b.productColor || !b.model) {
          return 0;
        }

        if (a.level !== b.level) {
          return b.level - a.level;
        } else if (a.productName !== b.productName) {
          return a.productName.localeCompare(b.productName);
        } else if (a.productColor !== b.productColor) {
          return a.productColor.localeCompare(b.productColor);
        } else if (a.model !== b.model) {
          return a.model.localeCompare(b.model);
        } else {
          return 0;
        }
      };
      this.redundantPlanAsinStockList.sort(sortFun);
    },
    removeProductFromPlan(row) {
      if (row.removeCount > 0) {
        row.removeCount = row.removeCount + row.outStockCount;
      } else {
        row.removeCount = row.outStockCount;
      }
      row.outStockCount = 0;

      this.initChooseOutStockPlanForReduce();
    },
    onRedundantCountClick(row) {
      this.$prompt("请输入移除数量", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        // inputPattern: /^\d+$/,
        inputErrorMessage: "请输入正确的数量",
        inputValue: row["removeCount"],
      })
        .then(({ value }) => {
          let maxRedundantOutStockCount = row.maxRedundantOutStockCount;
          if (value > maxRedundantOutStockCount + row.redundantOutStockCount || value < 0) {
            this.$message({
              type: "error",
              message: "请输入正确的数量",
            });
            return;
          }

          let totalCount = row.redundantOutStockCount + maxRedundantOutStockCount;
          let newOutStockCount = totalCount - value;
          if (newOutStockCount % this.chooseOutStockPlan.boxType != 0) {
            this.$message({
              type: "error",
              message: "请输入正确的数量",
            });
            return;
          }

          row.maxRedundantOutStockCount = parseInt(value);
          row.redundantOutStockCount = totalCount - parseInt(value);
          this.refreshRedundantOpreateBox();
          this.$refs.redundantTable.doLayout();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    onRemoveCountClick(row) {
      this.$prompt("请输入冗余数量", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        // inputPattern: /^\d+$/,
        inputErrorMessage: "请输入正确的数量",
        inputValue: row["removeCount"],
      })
        .then(({ value }) => {
          if (value > row.outStockCount + row.removeCount || value < 0) {
            this.$message({
              type: "error",
              message: "请输入正确的数量",
            });
            return;
          }
          let totalCount = row.outStockCount + row.removeCount;
          let newOutStockCount = totalCount - value;
          if (newOutStockCount % this.chooseOutStockPlan.boxType != 0) {
            this.$message({
              type: "error",
              message: "请输入正确的数量",
            });
            return;
          }

          row.removeCount = value;
          row.outStockCount = totalCount - value;
          this.initChooseOutStockPlanForReduce();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    getRedundantOutStockList() {
      let list = [];
      this.purchasePlansForOutStock.forEach(item => list.push({ ...item, sku: item["seller-sku"] }));
      let sortFun = function (a, b) {
        if (!a.productName || !a.productColor || !a.model || !b.productName || !b.productColor || !b.model) {
          return 0;
        }

        if (a.level !== b.level) {
          return b.level - a.level;
        } else if (a.shopType !== b.shopType) {
          return a.shopType - b.shopType;
        } else if (a.productName !== b.productName) {
          return a.productName.localeCompare(b.productName);
        } else if (a.productColor !== b.productColor) {
          return a.productColor.localeCompare(b.productColor);
        } else if (a.model !== b.model) {
          return a.model.localeCompare(b.model);
        } else {
          return 0;
        }
      };
      list.sort(sortFun);
      return list;
    },
    getReduceOutStockList(boxType) {
      let asinStockList = this.getAsinStockList(boxType);
      asinStockList = asinStockList.filter(asinStock => asinStock.outStockCount > 0);
      let sortFun = function (a, b) {
        if (!a.productName || !a.productColor || !a.model || !b.productName || !b.productColor || !b.model) {
          return 0;
        }

        if (a.level !== b.level) {
          return a.level - b.level;
        } else if (a.shopType !== b.shopType) {
          return a.shopType - b.shopType;
        } else if (a.productName !== b.productName) {
          return a.productName.localeCompare(b.productName);
        } else if (a.productColor !== b.productColor) {
          return a.productColor.localeCompare(b.productColor);
        } else if (a.model !== b.model) {
          return a.model.localeCompare(b.model);
        } else {
          return 0;
        }
      };
      asinStockList.sort(sortFun);
      return asinStockList;
    },
    getAsinStockList() {
      let asinStockList = this.outStockPlan.noBoxAsinStockList;
      let boxs = this.outStockPlan.boxs;
      boxs.forEach(box => (asinStockList = asinStockList.concat(box.asinStockList)));

      return asinStockList;
    },
    getPlanTypeLabel(boxType) {
      let label = "";
      boxType == 1 && (label = "不分箱");
      boxType == 2 && (label = "分2箱");
      boxType == 3 && (label = "分3箱");
      boxType == 4 && (label = "分4箱");
      boxType == 5 && (label = "分5箱");
      return label;
    },
    fetchOutStockBoxs() {
      requestModules.fetchOutStockBoxs({ status: 1 }).then(res => {
        this.outStockBoxs = res.ldata;

        this.calcOutStockPlan();
      });
    },
    fetchOutStockPlan() {
      requestModules.fetchOutStockPlan(this.params).then(res => {
        this.outStockPlan = res.mdata;

        this.fetchOutStockBoxs();

        this.fetchPurchasePlansForOutStock();
      });
    },
    calcOutStockPlan() {
      let dataList = [];
      this.outStockBoxs.forEach(box => {
        let data = { ...box };
        delete data._id;
        for (let i = 1; i <= 5; i++) {
          data["countFor" + i + "Box"] = data.bubbleWeight * this.perBubbleWeightCount * i;
          if (i == 2) {
            data["countFor" + i + "Box"] = Math.round(data["countFor" + i + "Box"] / 2) * 2;
          } else if (i == 3) {
            data["countFor" + i + "Box"] = Math.round(data["countFor" + i + "Box"] / 3) * 3;
          } else if (i == 4) {
            data["countFor" + i + "Box"] = Math.round(data["countFor" + i + "Box"] / 4) * 4;
          } else if (i == 5) {
            data["countFor" + i + "Box"] = Math.round(data["countFor" + i + "Box"] / 5) * 5;
          }

          data["realWeightFor" + i + "Box"] = data["countFor" + i + "Box"] * this.averageProductWeight;
          data["chargeableWeightFor" + i + "Box"] = Math.ceil(data.chargeableWeight * i);

          if (i == 5) {
            data["bulkFeeFor" + i + "Box"] = 0;
          } else {
            data["bulkFeeFor" + i + "Box"] = data["countFor" + i + "Box"] * 0.21 * 7;
          }

          data["logisticsCostFor" + i + "Box"] = this.perKgFee * data["chargeableWeightFor" + i + "Box"];
          data["sumFeeFor" + i + "Box"] = data["bulkFeeFor" + i + "Box"] + data["logisticsCostFor" + i + "Box"];
          data["perKgCostFor" + i + "Box"] = data["sumFeeFor" + i + "Box"] / data["realWeightFor" + i + "Box"];
        }
        dataList.push(data);
      });
      // console.log(dataList);

      dataList.sort((a, b) => a.bubbleWeight - b.bubbleWeight);

      this.calcData = dataList;

      // this.calcRecommendPlan();
    },
    calcRecommendPlan() {
      let planList = [];
      let boxTypeList = [5];
      for (let i = 0; i <= boxTypeList.length; i++) {
        let boxType = boxTypeList[i];
        let minBoxProductCount = 10000;
        let maxBoxProductCount = 0;
        let minOutStockCount = this.outStockPlan["outStockCountFor" + boxType + "Box"] - parseInt(this.reduceCount);
        let maxOutStockCount = this.outStockPlan["outStockCountFor" + boxType + "Box"] + parseInt(this.redundantCount);

        let boxList = [];
        this.calcData.forEach(data => {
          boxList.push({
            "boxId": data.boxId,
            "boxModel": data.length + "*" + data.width + "*" + data.height,
            "volume": data.volume,
            "bubbleWeight": data.bubbleWeight,
            "count": data["countFor" + boxType + "Box"],
            "sumFee": data["sumFeeFor" + boxType + "Box"],
            "realWeight": data["realWeightFor" + boxType + "Box"],
            "perKgCostFor": data["perKgCostFor" + boxType + "Box"],
            boxType,
          });

          minBoxProductCount > data.countFor1Box && (minBoxProductCount = data.countFor1Box);
          maxBoxProductCount < data.countFor1Box && (maxBoxProductCount = data.countFor1Box);
        });

        const combinations = this.getAllCombinations(boxList, minOutStockCount, maxOutStockCount, boxType);
        planList = planList.concat(combinations);
      }
      planList.sort((a, b) => a.perKgCost - b.perKgCost);

      this.outStockPlanList = planList.slice(0, 50);
      console.log(planList);
    },
    getAllCombinations(boxList, minOutStockCount, maxOutStockCount, boxType) {
      const n = boxList.length;
      const result = [];
      const counts = new Array(n).fill(0); // 存储每个字母的出现次数
      let recommendOutStockCount = this.outStockPlan["outStockCountFor" + boxType + "Box"];

      function recurse(index, currentLength) {
        if (index === n) {
          // 生成当前组合
          const combination = [];
          for (let i = 0; i < n; i++) {
            for (let j = 0; j < counts[i]; j++) {
              combination.push(boxList[i]);
            }
          }
          let totalCount = 0;
          let totalFee = 0;
          let perKgCost = 0;
          let realWeight = 0;
          let planType = 1;
          combination.forEach(box => {
            totalCount += box.count;
            totalFee += box.sumFee;
            realWeight += box.realWeight;
            perKgCost = totalFee / realWeight;
          });
          totalCount > recommendOutStockCount && (planType = 2);
          totalCount < recommendOutStockCount && (planType = 3);
          totalCount >= minOutStockCount && totalCount <= maxOutStockCount && result.push({ boxList: combination, totalCount, totalFee, realWeight, perKgCost, boxType, planType });
          // result.push({ boxList: combination, totalCount, totalFee, realWeight, perKgCost, boxType, planType });
          return;
        }

        // 枚举当前字母的出现次数（0到n次）
        for (let count = 0; count <= n; count++) {
          const newLength = currentLength + count;
          // 如果总长度超过限制则跳过
          if (newLength > n) break;

          counts[index] = count; // 设置当前字母出现次数
          recurse(index + 1, newLength); // 处理下一个字母
        }
      }

      recurse(0, 0); // 从第一个字母开始，当前长度0
      return result;
    },
    getCombinationsBacktrack(boxList, minOutStockCount, maxOutStockCount) {
      const result = [];
      backtrack(0, []);
      return result;

      function backtrack(start, current) {
        let totalCount = 0;
        let totalFee = 0;
        let perKgCost = 0;
        let realWeight = 0;
        current.forEach(box => {
          totalCount += box.countFor1Box;
          totalFee += box.sumFeeFor1Box;
          realWeight += box.realWeightFor1Box;
          perKgCost = totalFee / realWeight;
        });

        totalCount >= minOutStockCount && totalCount <= maxOutStockCount && result.push({ boxList: [...current], totalCount, totalFee, realWeight, perKgCost }); // 添加当前子集
        for (let i = start; i < boxList.length; i++) {
          current.push(boxList[i]); // 选择当前元素
          backtrack(i + 1, current); // 递归下一层
          current.pop(); // 撤销选择（回溯）
        }
      }
    },
    getLogisticsTypeLabel(logisticsType) {
      let label = "";
      logisticsType == 1 && (label = "红单快递");
      logisticsType == 2 && (label = "美森正班");
      logisticsType == 3 && (label = "海派海卡");
      return label;
    },
    calculateHeight() {
      this.screenHeight = document.body.clientHeight - 64 - 132 - 68;
    },
    copySku(sku) {
      navigator.clipboard
        .writeText(sku)
        .then(() => {
          this.$message.success("已复制SKU");
        })
        .catch(error => {
          this.$message.error("复制SKU失败");
        });
    },
  },
};
</script>

<style lang="scss">
#OutStockCalcPlan {
  .breadcrumb-box {
    .back-btn {
      vertical-align: middle;
      margin-right: 10px;
    }
    .el-breadcrumb {
      margin: 20px 0px;
      display: inline-block;
      vertical-align: middle;
    }
  }
  input[aria-hidden="true"] {
    display: none !important;
  }

  .form-line {
    .form-label {
      margin: 5px 10px 5px 0px;
      width: 80px;
      text-align: right;
      display: inline-block;
      span {
        color: red;
      }
    }
    .form-input {
      width: 200px;
      margin: 5px 0px;
      vertical-align: middle;
    }
    .form-group {
      width: 750px;
      margin: 5px 0px;
      display: inline-block;
      vertical-align: top;

      .el-checkbox {
        width: 70px;
      }
    }
  }

  .plan-conent {
    padding: 20px;
    margin-bottom: 50px;
    background-color: white;

    .shop-content,
    .box-content {
      margin-bottom: 20px;
      .title-content {
        font-size: 14px;
        margin-right: 20px;
        height: 35px;
        line-height: 35px;

        .title-label {
          font-size: 14px;
          font-weight: bold;
        }
      }
      .opreate-btn {
      }
    }

    .box-content {
      .merge-table .cell {
        .el-radio .el-radio__label {
          display: none;
        }
      }
      .el-table {
        margin-top: 20px;

        td {
          padding: 3px 0 !important;
        }

        .el-table__header col {
          padding-left: 2px;
          padding-right: 2px;
        }

        .el-table__header .cell {
          padding-left: 2px;
          padding-right: 2px;
          line-height: 14px;
        }
      }
      .el-table .cell {
        padding-left: 2px;
        padding-right: 2px;
        line-height: 14px;

        -webkit-user-select: none; /* Safari */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently supported by Chrome, Opera and Firefox */

        .row-item {
          min-height: 14px;
        }
      }

      .el-table tr:hover {
        background-color: #f9f981;
      }

      .el-table tr:hover td {
        background-color: transparent;
      }

      .el-table .current-row {
        background-color: #f9f981;

        .el-table__cell {
          background-color: #f9f981;
        }
      }
    }
    .plan-info {
      .box-info {
        margin-left: 10px;
        display: inline-block;

        .box-count {
        }
        .box-model {
          background-color: green;
          color: white;
          height: 16px;
          line-height: 16px;
          padding: 2px 5px;
          border-radius: 5px;
        }
      }
    }

    .opreate-box {
      height: 60px;
      line-height: 60px;
      margin: 5px 10px;

      .opreate-text {
        margin-right: 20px;
      }
    }

    .redBg {
      background-color: red;
      color: white;
    }
    .yellowBg {
      background-color: yellow;
    }
    .greenBg {
      background-color: green;
      color: white;
    }
    .redText {
      color: red;
    }
    .greenText {
      color: green;
    }
    .greenYellowText {
      color: rgb(233, 104, 104);
    }
    .yellowText {
      color: rgb(112, 56, 56);
    }
  }
  .title-line {
    border-bottom: 1px solid gray;
    font-weight: bold;
    height: 30px;
    line-height: 30px;
  }
}
</style>
